import { AxiosResponse } from 'axios';
import { AxiosAPI } from './AxiosApi';

class DashboardApi extends AxiosAPI {
  public fetchAmericanStates = async (options = {}) => {
    try {
      const response = await this.GET(this.apiSchema.GET.waterSystems.americanStates(), options);
      return response as AxiosResponse;
    } catch (error) {
      throw error;
    }
  };

  public fetchWaterSystemsMetrics = async (options = {}) => {
    try {   
    const response = await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystemMetrics(), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchWellWaterSystemsMetrics = async (options = {}) => {
    try {   
      const response = await this.GET(this.apiSchema.GET.waterSystems.wellWaterSystemMetrics(), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchMapWaterSystemsMetrics = async (options = {}) => {
    try {   
      const response = await this.GET(this.apiSchema.GET.waterSystems.mapPublicWaterSystemMetrics(), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchMapWellWaterSystemsMetrics = async (options = {}) => {
    try {   
      const response = await this.GET(this.apiSchema.GET.waterSystems.mapWellWaterSystemMetrics(), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchWaterSystems = async (zips: string, options = {}) => {
    try {
      const response = await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystems(zips), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchWellWaterSystems = async (zips: string, options = {}) => {
    try {
      const response = await this.GET(this.apiSchema.GET.waterSystems.wellWaterSystems(zips), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchPublicWaterSystemsByAddress = async (latitude: number, longitude: number, radius?: number, options = {}) => {
    try {
      const response = await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystemsByAddress(latitude, longitude, radius), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchPublicWaterSystemsByAddressComponent = async (city: string, state: string, zipCode: string, address1: string, options = {}) => {
    try {
      const response = await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystemsByAddressComponent(city, state, zipCode, address1), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchUtilityDetail = async (pwsid: string, options = {}) => {
    try {
      const response = await this.GET(this.apiSchema.GET.waterSystems.UtilityDetails(pwsid), options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchAggregatedWaterSystems = async (
    zoomLevel: string,
    stateCode?: string,
    options = {},
  ) => {
    try {
      const response = await this.GET(
        this.apiSchema.GET.waterSystems.publicWaterSystemAggregates(zoomLevel, stateCode),
        options,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  public fetchAggregatedWellWaterSystems = async (
    zoomLevel: string,
    stateCode?: string,
    stateName?: string,
    options = {},
  ) => {
    try {
      const response = await this.GET(
        this.apiSchema.GET.waterSystems.wellWaterSystemAggregates(zoomLevel, stateCode, stateName),
        options,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  public createWaterSystemCoordinates = async (body: any, options = {}) => {
    try {
      const response = await this.PUT(this.apiSchema.PUT.waterSystems.publicWaterSystemCoordinates(), body, options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public createWellWaterSystemCoordinates = async (body: any, options = {}) => {
    try {
      const response = await this.PUT(this.apiSchema.PUT.waterSystems.wellWaterSystemCoordinates(), body, options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public createWaterSystemGeoBlocks = async (body: any, options = {}) => {
    try {
      const response = await this.PUT(this.apiSchema.PUT.waterSystems.wellWaterSystemGeoBlocks(), body, options);
      return response;
    } catch (error) {
      throw error;
    }
  };

  public uploadWaterTestStrip = async (body: any, options = {}) => {
    try {
      const response = await this.POST(
        this.apiSchema.POST.waterTestStrips.upload(),
        body,
        options
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  public manualAnalyzeWaterTestStrip = async (body: any, options = {}) => {
    try {
      const response = await this.POST(
        this.apiSchema.POST.waterTestStrips.manualAnalyze(),
        body,
        options
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  public getWaterTestStripResult = async (jobId: string, options = {}) => {
    try {
      const response = await this.GET(
        this.apiSchema.GET.waterTestStrips.result(jobId),
        options
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  public getParameters = async (options = {}) => {
    return await this.GET(this.apiSchema.GET.waterTestParams.parameters(), options);
  }
  public getParameterDetails = async (parameterName: string, options = {}) => {
    return await this.GET(   this.apiSchema.GET.waterTestParams.parameterDetails(parameterName), options);
  };

  public submitWaterTestStripRequest = async (data: any, options = {}) => {
    try {
      const response = await this.POST(
        this.apiSchema.POST.waterTestStrips.waterTestStripRequest(),
        data,
        options
      )
      return response
    } catch (error) {
      throw error
    }
  }

  public sendOtp = async (email: string, options = {}) => {
    try {
      const response = await this.POST(
        this.apiSchema.POST.verification.sendOtp(),
        { email },
        options
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  public verifyOtp = async (email: string, otp: string, options = {}) => {
    try {
      const response = await this.POST(
        this.apiSchema.POST.verification.verifyOtp(),
        { email, otp },
        options
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  public resendOtp = async (email: string, options = {}) => {
    try {
      const response = await this.POST(
        this.apiSchema.POST.verification.resendOtp(),
        { email },
        options
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}

const dashboardApiInstance = new DashboardApi();

export default dashboardApiInstance;
